<template lang="pug">
    .login-box
        .login-box__header
            | {{ $i18n.t('auth.auth_common_auth') }}
        .login-box__body
            form.login-box__form(action="javascript://" @submit="submitForm")
                .login-box__item
                    cs-input(
                        :class="{'cs-input--error': errors.has('login')}"
                        type="text"
                        :placeholder="$i18n.t('auth.auth_login_loginPlaceholder')"
                        v-model="form.username"
                        v-validate="'required'"
                        name="login"
                        :data-vv-as="$i18n.t('auth.auth_login_loginPlaceholder').toLowerCase()"
                    )
                    help-text(v-show="errors.has('login')" :error="errors.has('login')")
                        | {{ errors.first('login')}}
                .login-box__item
                    cs-input(
                        :class="{'cs-input--error': errors.has('password')}"
                        type="password"
                        :placeholder="$i18n.t('auth.auth_login_passwordPlaceholder')"
                        v-model="form.password"
                        v-validate="'required|min:6'"
                        name="password"
                        :data-vv-as="$i18n.t('auth.auth_login_passwordPlaceholder').toLowerCase()"
                    )
                    help-text(v-show="errors.has('password')" :error="errors.has('password')")
                        | {{ errors.first('password')}}
                cs-checkbox.login-box__item(v-model="stayInSystem")
                    | {{ $i18n.t('auth.auth_login_save') }}
                cs-button(
                    type="submit"
                    color="blue"
                    :loading="isLoading"
                    :fullWidth="true"
                ) {{ $i18n.t('auth.auth_login_button') }}
            .login-box__footer
                .login-box__link-container
                    router-link.login-box__link(:to="{name: 'forgot'}")
                        | {{ $i18n.t('auth.auth_login_forgot') }}
                hr.login-box__divider
                .login-box__link-container
                    a.login-box__link(href="javascript://" @click="openModal")
                        | {{ $i18n.t('auth.auth_login_register') }}
        cs-modal(v-if="isModalOpened" :is-blur="true" @close="closeModal")
            .modal__text
                | {{ $i18n.t('auth.auth_login_registrationInfo.line1') }}
                br
                | {{ $i18n.t('auth.auth_login_registrationInfo.line2.part1') }}
            .modal__button
                cs-button(
                    href="http://cleverstart.ru/"
                    color="blue"
                    :fullWidth="true"
                    html-tag="a"
                )
                    | {{ $i18n.t('auth.auth_login_toSite') }}
                cs-button(
                    :style="{marginTop: '10px'}"
                    @click="goToRegisterPage"
                    color="green"
                    :fullWidth="true"
                )
                    | {{ $i18n.t('auth.auth_olympiadRegistration_register') }}

</template>

<script>
    import HelpText from '../../elements/HelpText.vue';
    const CsModal = () => import('../../elements/CsModal.vue');

    export default {
        components: {
            CsModal,
            HelpText,
        },
        data() {
            return {
                form: {
                    username: '',
                    password: '',
                },
                isModalOpened: false,
                stayInSystem: false,
                isLoading: false,
            };
        },
        created() {
            if (this.$route.params.lang) {
                this.$i18n.locale = this.$route.params.lang;
                this.$validator.localize(this.$i18n.locale);
            }
            const localeFromLocalStorage = window.localStorage.getItem('locale');
            if (localeFromLocalStorage) {
                this.$i18n.locale = localeFromLocalStorage;
                this.$validator.localize(this.$i18n.locale);
            }
            if (this.$route.query.username && this.$route.query.password) {
                this.form.username = this.$route.query.username;
                this.form.password = this.$route.query.password;
                this.submitForm();
            }
        },
        methods: {
            submitForm() {
                if (!this.isLoading) {
                    return this.$validator
                        .validateAll()
                        .then(isValid => {
                            this.isLoading = true;
                            return isValid ? this.$store.dispatch('signIn', this.form) : Promise.reject();
                        })
                        .then(() => {
                            this.isLoading = false;
                        })
                        .catch(err => {
                            this.isLoading = false;
                            if (this.errors.has('login') || this.errors.has('password')) {
                                this.$toasted.error(this.$i18n.t('errors.fill_form'));
                            }
                            if (err && err.response && err.response.status !== 500) {
                                this.errors.add('password', this.$i18n.t('auth.auth_login_errorIncorrect'));
                            }
                            if (!err) {
                                return Promise.resolve();
                            }
                        });
                }
                return Promise.resolve();
            },
            openModal() {
                this.isModalOpened = true;
            },
            closeModal() {
                this.isModalOpened = false;
            },
            goToRegisterPage() {
                this.$router.push({ name: 'registration' });
            },
        },
    };
</script>

<style lang="scss" scoped>
    .login-box {
        margin: 0 auto;
        background-color: $x-color-white;
        @include media($sm) {
            border-radius: 40px;
            max-width: 400px;
        }
        @include media($md) {
            max-width: 600px;
        }
    }

    .login-box__header {
        font-size: 32px;
        line-height: 38px;
        font-weight: 500;
        text-align: center;
        padding-top: 40px;
    }

    .login-box__body {
        padding-top: 13px;
    }

    .login-box__footer {
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    .login-box__divider {
        border: 0;
        margin: 0;
        background: $hsl-color-gray-74;
        height: 1px;
        width: calc(100% - 60px);
    }

    .login-box__link-container {
        padding: 20px 0;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    }

    .login-box__link {
        color: $hsl-color-blue-56;
        text-decoration: underline;

        &:hover {
            color: $hsl-color-blue-56;
            text-decoration: none;
        }
    }

    .login-box__form {
        max-width: 260px;
        @include media($md) {
            max-width: 300px;
        }
        margin: 0 auto;
    }

    .login-box__item {
        padding-bottom: 14px;
    }

    .modal__text {
        font-size: 16px;
        line-height: 24px;
        text-align: center;
    }

    .modal__button {
        padding-top: 13px;
        max-width: 192px;
        margin: 0 auto;
    }
</style>
